import MentoringCard from './container';

export default MentoringCard;
